import React from 'react';
import {Icon, useQueryParams} from 'shared/helpers';
import {Search} from 'shared/components/Product/Search';
import {CategoriesAndItems} from 'shared/components/Product/CategoriesAndItems';
import {Breadcrumbs, Product} from 'components/customer/Product';
import {Header} from 'components/customer/RoomPlanner/components/Menu/Header';
import styled from 'styled-components';
import {
    useIsMobileLandscape,
    useIsPortraitDevices,
} from 'shared/helpers/DeviceSize';
import {CancelButton} from 'shared/components/CancelButton';
import {Col, Row} from 'react-bootstrap';
import {mobileLandscape, mobilePortrait} from 'shared/Breakpoints';
import {useRoomPlannerLeftMenu} from 'components/customer/RoomPlanner/helper/useRoomPlannerLeftMenu';
import {useSearchParams} from 'react-router-dom';

export interface ProductsProps {
    showTitle?: boolean;
    isMiniBrowser?: boolean;
}

export const Products = ({showTitle, isMiniBrowser = false}: ProductsProps) => {
    const {isRoomPlannerPage} = useRoomPlannerLeftMenu();
    const isMobileLandscape = useIsMobileLandscape();
    const isPortraitDevices = useIsPortraitDevices();
    const isMobileDevice = isMobileLandscape || isPortraitDevices;
    const [searchParams] = useSearchParams();

    const {product, cabinetId, copy} = useQueryParams() as {
        product: string;
        cabinetId: string;
        copy?: string;
    };
    const isProductView = !!product;

    return (
        <ProductsContainer
            $isMiniBrowser={isMiniBrowser}
            $isProduct={isProductView}
            className={
                !isProductView
                    ? 'Products product'
                    : 'Products product bottomMargin'
            }>
            {showTitle ? (
                <h1>
                    <Icon iconName="Headers-Add-Product.svg" />
                    <label>
                        {copy ? 'Copy' : cabinetId ? 'Edit' : 'Add'} Product
                    </label>
                </h1>
            ) : null}

            <div className="product-content">
                {product ? (
                    isMiniBrowser ? (
                        <Header />
                    ) : (
                        <div className="search-info">
                            <Breadcrumbs />
                        </div>
                    )
                ) : null}
                <div>
                    {!isProductView ? <Search /> : null}

                    <ProductsAndCategories
                        $isMiniBrowser={isMiniBrowser}
                        className="productsAndCategories">
                        {!product ? (
                            <CategoriesAndItems isProduct={true} />
                        ) : (
                            <Product />
                        )}
                    </ProductsAndCategories>
                    {isMobileDevice &&
                    isRoomPlannerPage &&
                    searchParams &&
                    !searchParams.has('product') ? (
                        <MobileControls className="control-buttons">
                            <Col xs={{offset: 3, span: 6}}>
                                <CancelButton
                                    noDialog={true}
                                    noRedirect={true}
                                />
                            </Col>
                        </MobileControls>
                    ) : null}
                </div>
            </div>
        </ProductsContainer>
    );
};

export const MobileControls = styled(Row)`
    padding-bottom: 15px;
    margin-right: 0;
    margin-left: -10px;
    padding-top: 15px;
    box-shadow: 0 0 7px 0px #bbbbbb;

    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding-left: 15px;
    z-index: 10;
    background: white;

    > div > button {
        width: 100%;
    }

    ${mobilePortrait`
        > div > button {
            padding: 5px;
            font-size: .85em;

            > img {
                width: 20px !important;
            }
        }
        z-index: 100;
    `}

    ${mobileLandscape`
        position: absolute;
        margin-left: 0;
        z-index: 100;
    `}
`;

const ProductsContainer = styled.div<{
    $isMiniBrowser: boolean;
    $isProduct: boolean;
}>`
    ${({$isMiniBrowser, $isProduct}) => {
        if ($isMiniBrowser && $isProduct) {
            return 'margin-bottom: 105px !important;';
        }
    }}
`;

const ProductsAndCategories = styled.div<{
    $isMiniBrowser?: boolean;
}>`
    ${({$isMiniBrowser}) => {
        if ($isMiniBrowser) {
            return `min-height: 600px`;
        }
    }}
`;
